<form [formGroup]="mainForm" (ngSubmit)="save()">
  <nb-card>
    <nb-card-header>
      <div class="title">
        <a><span (click)="customerDetail()">{{customer.name}}</span></a> - {{data.routeName}}
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class="form-group">
        <div class="row">
          <label class="col-sm-4 col-form-label">Delivery type<span class="required">*</span> </label>
          <div class="col-sm-8">
            <ngx-radio [list]="customerDropDownData.DeliveryTypeDropDown" [controlName]="'deliveryType'"
              [inLine]="true">
            </ngx-radio>
          </div>
        </div>
      </div>
      <div class="form-group wrapper mt-4" *ngIf="mainForm.controls['deliveryType'].value !== DeliveryTypeEnum.CallIn">
        <div class="row mb-3">
          <div class="col-sm-12">
            <ngx-radio [disabled]="mainForm.controls['deliveryType'].value === DeliveryTypeEnum.CallIn"
              [list]="customerDropDownData.RecurringTypeDropDown" [controlName]="'recurringType'" [inLine]="true">
            </ngx-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" *ngIf="mainForm.controls['recurringType'].value === RecurringTypeEnum.Monthly">
            <div class="col-sm-12">
              <ngx-select [disabled]="mainForm.controls['deliveryType'].value === DeliveryTypeEnum.CallIn"
                required="false" [control]="mainForm.controls.weekOfMonth"
                [list]="customerDropDownData.WeekOfMonthDropDown">
              </ngx-select>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-sm-12 error-message" *ngIf="data.isStartedToday && !isAllowAdd()">
          Only allow add Call-in when route started
        </div>
      </div> -->
    </nb-card-body>
    <nb-card-footer>

      <div class="row">
        <div class="col-sm-6 mb-2">
          <button nbButton fullWidth [disabled]="isInvalid() || isLoading" class="w-100" status="primary" type="submit">
            {{isAddCustomer ? 'Add' : 'Save'}}
          </button>
        </div>
        <div class="col-sm-6 mb-2">
          <button fullWidth nbButton status="info" (click)="cancel()" class="button-cancel w-100">
            Cancel
          </button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</form>